import { NgModule } from '@angular/core'
import {
  AuthModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  ProductModule,
  ProductOccModule, UserModule, UserOccModule,
} from '@spartacus/core'
import {
  AddressBookModule,
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  LoginRouteModule,
  LogoutModule,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PaymentMethodsModule,
  ProductCarouselModule,
  ProductDetailsPageModule,
  ProductFacetNavigationModule,
  ProductImagesModule,
  ProductIntroModule,
  ProductListingPageModule,
  ProductListModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductSummaryModule,
  ProductTabsModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  StockNotificationModule,
  TabParagraphContainerModule,
} from '@spartacus/storefront'
import { UserFeatureModule } from './features/user/user-feature.module'
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module'
import { CartSavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module'
import { CartQuickOrderFeatureModule } from './features/cart/cart-quick-order-feature.module'
import { OrderFeatureModule } from './features/order/order-feature.module'
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module'
import { CartBaseModule } from '@spartacus/cart/base'
import { WishListModule } from '@spartacus/cart/wish-list'
import { CartPageEventModule } from '@spartacus/cart/base/core'
import { CartBaseOccModule } from '@spartacus/cart/base/occ'
import { CartBaseRootModule } from '@spartacus/cart/base/root'
import { CheckoutRootModule } from '@spartacus/checkout/base/root'
import { CartBaseComponentsModule } from '@spartacus/cart/base/components'

@NgModule({
  imports: [
    // Auth Core
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,

    // Basic Cms Components
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,

    // User Core
    // TODO: Spartacus Upgrade - checkpoint after testing
    // UserTransitional_4_2_Module,
    // UserOccTransitional_4_2_Module,
    UserModule,
    UserOccModule,

    // User UI,
    AddressBookModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,

    // Product Core,
    ProductModule.forRoot(),
    ProductOccModule,

    // Product UI,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,

    // Cart Base Core,
    CartBaseModule,
    CartBaseOccModule,
    CartBaseRootModule,

    // Cart UI,
    // TODO: Spartacus Upgrade - checkpoint after testing
    // CartComponentModule,
    CartBaseComponentsModule,
    WishListModule,

    // Cost Center
    CostCenterOccModule,

    // Checkout
    CheckoutRootModule,

    // Page Events,
    NavigationEventModule,
    HomePageEventModule,
    CartPageEventModule,
    ProductPageEventModule,

    // External routes,
    ExternalRoutesModule.forRoot(),

    // Feature libraries
    CartQuickOrderFeatureModule,
    CartSavedCartFeatureModule,
    CartBaseFeatureModule,
    CheckoutFeatureModule,
    OrderFeatureModule,
    UserFeatureModule,
  ]
})
export class SpartacusFeaturesModule {
}
